import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkMoreInfoTrigger } from 'uitk-react-more-info-trigger';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';
import { AnchorTracked } from '../../utils/click-trackers';
export var SortDisclaimer = function (_a) {
  var _b, _c;
  var data = _a.data;
  var text = data.text,
    icon = data.icon;
  var clickAction = data.clickAction;
  return React.createElement(UitkMoreInfoTrigger, null, React.createElement(AnchorTracked, {
    linkName: (_b = clickAction === null || clickAction === void 0 ? void 0 : clickAction.analytics) === null || _b === void 0 ? void 0 : _b.linkName,
    rfrr: (_c = clickAction === null || clickAction === void 0 ? void 0 : clickAction.analytics) === null || _c === void 0 ? void 0 : _c.referrerId,
    href: clickAction === null || clickAction === void 0 ? void 0 : clickAction.anchorTagUrl,
    target: (clickAction === null || clickAction === void 0 ? void 0 : clickAction.opensInNewTab) ? '_blank' : '_self',
    rel: "noopener",
    "data-testid": "sort-disclaimer"
  }, React.createElement("span", null, text && React.createElement(UitkText, {
    size: 300,
    weight: "bold"
  }, text)), icon && React.createElement(UitkSpacing, null, React.createElement(UitkIcon, {
    id: icon === null || icon === void 0 ? void 0 : icon.id,
    name: icon === null || icon === void 0 ? void 0 : icon.id,
    size: UitkIconSize.EXTRA_SMALL,
    description: icon === null || icon === void 0 ? void 0 : icon.description
  })), (clickAction === null || clickAction === void 0 ? void 0 : clickAction.accessibilityText) && React.createElement("span", {
    className: "is-visually-hidden"
  }, clickAction === null || clickAction === void 0 ? void 0 : clickAction.accessibilityText)));
};